import type { HistoricoParecerPAItemResponse } from '../types/vida/adhesionProposal/adhesionProposalType';

export type ParecerStatusType = 'recusado' | 'em_analise' | 'aprovado';

export type ParecerHistoricoItem = {
  id: number;
  date: string;
  dateTime: string;
  status: ParecerStatusType;
  statusCode: string;
  refusalCode: string | null;
  refusalType: string;
  observation: string;
  analyst: string;
};

export const PARECER_STATUS_LABELS: Record<ParecerStatusType, string> = {
  recusado: 'Recusado',
  em_analise: 'Em Análise',
  aprovado: 'Aprovado',
};

export const PARECER_STATUS_COLORS: Record<ParecerStatusType, string> = {
  recusado: '#CC092F',
  em_analise: '#C4A35A',
  aprovado: '#0da31c',
};

export const mapStatusParecerToType = (statusParecer: string): ParecerStatusType => {
  const code = Number(statusParecer);

  if (code === 2) {
    return 'recusado';
  }

  if (code === 1 || code === 4 || code === 8) {
    return 'aprovado';
  }

  return 'em_analise';
};

export const formatParecerDateTime = (
  horaManut: string
): { date: string; dateTime: string } => {
  if (!horaManut) {
    return { date: '—', dateTime: '—' };
  }

  const [datePart, timePart = ''] = horaManut.split(' ');
  const [year, month, day] = datePart.split('-');

  if (!year || !month || !day) {
    return { date: horaManut, dateTime: horaManut };
  }

  const date = `${day}/${month}/${year}`;
  const timeFormatted = timePart ? timePart.slice(0, 5) : '';

  return {
    date,
    dateTime: timeFormatted ? `${date} ${timeFormatted}` : date,
  };
};

export const mapHistoricoParecerItem = (
  item: HistoricoParecerPAItemResponse,
  index: number
): ParecerHistoricoItem => {
  const { date, dateTime } = formatParecerDateTime(item.horaManut);

  return {
    id: index,
    date,
    dateTime,
    status: mapStatusParecerToType(item.statusParecer),
    statusCode: item.statusParecer,
    refusalCode: item.cdMotivoRecusa,
    refusalType: item.motivoRecusa || '—',
    observation: item.observacao || '—',
    analyst: item.usuarioInclusao || '—',
  };
};
